import type { PaymentMethodsConfig } from '../default/payment';
import type { DeepPartial } from '../default/types';

export const paymentMethodsConfig: DeepPartial<PaymentMethodsConfig> = {
  paymentMethods: {
    imageBased: ['visa', 'mastercard', 'amex', 'diners', 'discover', 'paypal'],
    textBased: ['invoice', 'installments', 'bank_debit'],
  },
  // ORDER-4147: BAUR opts in to the invoice/installments credit-check hint.
  showCreditCheckHint: true,
};
